module.exports = __webpack_public_path__ + "img/q30-6.7c3fd807.jpg";